import mapboxgl from 'mapbox-gl';

import 'mapbox-gl/dist/mapbox-gl.css';

document.addEventListener('DOMContentLoaded', () => {
  const mapDiv = document.querySelectorAll('.contact-map');

  if (mapDiv.length > 0) {
    mapboxgl.accessToken =
      'pk.eyJ1IjoiYWNyb3NzLW1hcmtldGluZyIsImEiOiJjbThlOXNqMjcyMng4MmtzNTc1MHF6OTVuIn0.blrzbFmF363-O4w9vy3mOg';

    mapDiv.forEach((mapDiv) => {
      const mapLat = mapDiv.getAttribute('data-map-lat');
      const mapLng = mapDiv.getAttribute('data-map-lng');

      // Find parent .tab-container
      const currentTabId = mapDiv.closest('.tab-container').getAttribute('id');

      if (!mapLat || !mapLng) {
        return;
      }

      const map = new mapboxgl.Map({
        container: mapDiv,
        style: 'mapbox://styles/mapbox/light-v11',
        center: [Number(mapLat), Number(mapLng)],
        zoom: 17,
      });

      new mapboxgl.Marker({
        color: '#7E6098',
      })
        .setLngLat([Number(mapLat), Number(mapLng)])
        .addTo(map);

      document.addEventListener('e_tabs_nav_initialized', function (event) {
        const initializedTabId = event.detail?.activeTab;

        if (initializedTabId == currentTabId) {
          map.resize();
        }
      });

      // Only resize map when current accordion button is clicked
      document.addEventListener('e_tabs_nav_item_clicked', function (event) {
        const clickedTabId = event.detail?.id;

        if (clickedTabId == currentTabId) {
          map.resize();
        }
      });
    });
  }
});
